import { motion } from 'framer-motion';
import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';

const Chapters: React.FC = () => {
  const { t } = useI18n();

  // Get all chapter keys from translations
  const chapterKeys = Object.keys(t.chapters).filter(key => key.startsWith('chapter'));

  // Sort chapters by their number
  const sortedChapters = chapterKeys
    .sort((a, b) => {
      const numA = parseInt(a.replace('chapter', ''));
      const numB = parseInt(b.replace('chapter', ''));
      return numA - numB;
    })
    .map(key => ({
      title: t.chapters[key].title,
      subtitle: t.chapters[key].subtitle,
      description: t.chapters[key].description,
    }));

  return (
    <section id='chapters' className='py-20 bg-gradient-to-b from-gray-50 to-white'>
      <div className='container mx-auto px-4'>
        <h2 className='text-4xl font-bold text-center mb-12 text-gray-800'>{t.chapters.sectionTitle}</h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {sortedChapters.map((chapter, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className='bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300'
            >
              <h3 className='text-xl font-bold text-blue-600 mb-2'>{chapter.title}</h3>
              <h4 className='text-lg font-semibold text-gray-800 mb-3'>{chapter.subtitle}</h4>
              <p className='text-gray-600'>{chapter.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Chapters;
